<template>
  <div class="exerciseContainer">
    <div>
      <Header :pageTitle="'病例练习'" :minWidth="22" v-if="showHeader && isApp">
        <template #reportBtn>
          <div class="shareWrapper">
            <div class="report"></div>
            <span @click.stop="goReport">报告</span>
          </div>
        </template>
        <template v-slot:shareBtn>
          <div class="shareWrapper" @click.stop="shareFn">
            <div class="shareBtn icon-share-black"></div>
          </div>
        </template>
      </Header>
    </div>
    <div class="exerciseTop" v-show="loaded">
      <div class="infoWrapper" :class="{ browserPort: !isApp }">
        <div class="interestsBox" @click.stop="goGuide">
          <div class="exerciseInterests">
            <div class="thisWeek">本周</div>
            <div class="promptText">
              <span
                class="none"
                v-if="userInfo.finishedMedicaseCount === 0 || !isLogin"
                >尚未开始练习</span
              >
              <div class="testInfo" v-else>
                <p>完成</p>
                <p class="num">{{ userInfo.finishedMedicaseCount }}</p>
                <p>个病例</p>
              </div>
            </div>
          </div>
          <div class="interestsTime">
            <template
              v-if="userInfo.role == 'MEMBER' || userInfo.role == 'TRIAL'"
            >
              <!-- 会员(体验会员)有效期内 -->
              <div class="interestsValidity">
                有效期：剩余{{ userInfo.expiredDayCount }}天
              </div>
            </template>
            <template
              v-else-if="
                userInfo.role == 'MEMBER_EXPIRED' ||
                userInfo.role == 'TRIAL_EXPIRED'
              "
            >
              <!-- 会员用户会员(体验会员)已过期 -->
              <div class="interestsValidity">有效期:剩余0天</div>
              <div class="expiredBtn">已失效</div>
            </template>
            <template v-else>
              <!-- 会员用户会员已过期 -->
              <div class="interestsValidity">病例练习会员</div>
              <div class="interestsBtn">点击查看</div>
            </template>
          </div>
        </div>
        <div class="exerciseRecord infoItem" @click="goRecord">
          记录 <i class="recordIcon"></i>
        </div>
        <div class="infoItem wechatItem" v-if="wechatPort">
          <wx-open-launch-app
            id="launch-btn wechatOpenApp"
            appid="wxc48f4cdd885acc63"
            @launch="handleLaunchFn"
            @error="handleErrorFn"
            @ready="launchReady"
            :extinfo="JSON.stringify(extinfo)"
          >
            <component :is="'script'" type="text/wxtag-template">
              <div class="btn" :style="btnStyle"></div>
            </component>
          </wx-open-launch-app>
        </div>
        <div
          class="exerciseCollectionGray infoItem"
          v-else-if="grayBl && isApp"
        >
          收藏 <i class="collectionIconGray"></i>
        </div>
        <div
          class="exerciseCollection infoItem"
          @click.stop="toCollection"
          v-else
        >
          收藏 <i class="collectionIcon"></i>
        </div>
        <div class="learnReport infoItem" v-if="!isApp" @click.stop="goReport">
          报告 <i class="reportIcon"></i>
        </div>
      </div>
    </div>
    <!-- 未领取七天会员 -->
    <div
      class="exerciseCenter"
      v-show="loaded"
      v-if="userInfo.role === 'GUEST' || !isLogin"
    >
      <div class="exerciseReceive" @click.stop="receiveVip">免费领取 5天</div>
    </div>
    <!-- 选择兴趣（标签）后展示推荐 -->
    <div class="recommentWrapper" v-show="loaded" v-else>
      <dl class="recommendTitle flexBox">
        <dt>基于兴趣为您推荐</dt>
        <dd @click.stop="openPop = true">
          <span class="icon-change"></span> 切换兴趣
        </dd>
      </dl>
      <MedicaseItem
        v-for="(item, key) in recommendList"
        class="mdeicase-item"
        :showContext="true"
        :item="item"
        :ind="key"
        :key="item.medicaseId"
        :isLogin="isLogin"
      >
        <template #line v-if="key == 0">
          <div class="line"></div>
        </template>
      </MedicaseItem>
      <div class="reloadOther" @click.stop="getRecommend(true)">
        <span class="icon-reload"></span><span>&nbsp;换一批</span>
      </div>
    </div>
    <!-- 热门病例 -->
    <hot-cases v-show="loaded"></hot-cases>
    <!-- 兴趣偏好 -->
    <choose-interest
      :openPop="openPop"
      @controlPop="controlPop"
      :depId="depId"
    ></choose-interest>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@com/common/Header.vue'
import hotCases from '@/components/exercise/hot-cases/index.vue'
import {
  appPort,
  hiddenAppNavBar,
  isLogin,
  appShare,
  weixinShare,
  userLogin,
  queryToString,
  callAppView,
  jumpModuleApp,
  wechatPort,
  getUserId,
  androidPort,
  versionCompare
} from '@/widget/index'
import BScroll from '@better-scroll/core'
import MedicaseItem from '@com/list/medicaseItem.vue'
import { userMedicaseOverview, recommendedMedicase } from '@api/exercise'
import chooseInterest from '@/components/exercise/choose-interest/index.vue'
import { hostPath } from '@utils/basePath'

export default defineComponent({
  data() {
    return {
      isApp: appPort(),
      loaded: false, // 是否加载完成
      bs: null,
      userInfo: {},
      isLogin: isLogin,
      recommendList: [],
      openPop: false,
      shareInfo: {
        title: '邀请你一起参加病例练习，快速提升诊疗思维',
        desc: '丰富的病例，助您每日精进',
        url: hostPath + `/learn/medicase`,
        image: 'https://img-a.haoyishu.com/images/share/hys_logo.png'
      },
      pageNo: 1, // 兴趣推荐数据页码
      pages: 1, // 共有多少页
      depId: this.$route.query.depId || '',
      wechatPort: wechatPort(),
      extinfo: {
        typeId: 'smart_exercise_collection_list'
      },
      userId: getUserId(),
      btnStyle: {},
      grayBl: false, // 是否置灰收藏按钮
      showHeader: true // 是否显示头部
    }
  },
  watch: {},
  methods: {
    receiveVip() {
      if (!this.isLogin) {
        userLogin()
        return
      }
      let query = this.$route.query
      if (!query.depId) {
        query.depId = this.depId
      }
      // if (appPort()) {
      //   jumpModuleApp({
      //     typeId: 'h5',
      //     url: `${hostPath}/learn/medicase/success?${queryToString(query)}`,
      //     full_screen: true
      //   })
      // } else {
      //   this.$router.push({
      //     path: '/medicase/success',
      //     query
      //   })
      // }
      this.$router.push({
        path: '/medicase/success',
        query
      })
    },
    goRecord() {
      if (!this.isLogin) {
        userLogin()
        return
      }
      this.$router.push({
        path: '/medicase/record',
        query: {
          depId: this.depId
        }
      })
    },
    goReport() {
      if (!this.isLogin) {
        userLogin()
        return
      }
      this.$router.push({
        path: '/medicase/report',
        query: {
          depId: this.depId
        }
      })
    },
    goGuide() {
      // 进入病例练习导览页
      let query = this.$route.query
      if (!query.depId) {
        query.depId = this.depId
      }
      this.$router.push({
        name: 'guideExam',
        query: this.$route.query
      })
    },
    getUserMsg() {
      if (isLogin) {
        return userMedicaseOverview({
          departmentId: this.depId
        }).then(res => {
          if (res.code === 200) {
            this.userInfo = res.data
            this.depId = res.data.departmentId
            this.wxShare(res.data.departmentId)
          } else {
            this.$toast(res.message)
          }
        })
      } else {
        return new Promise(resolve => {
          this.wxShare()
          resolve()
        })
      }
    },
    getRecommend(bl) {
      // bl 是否为换一批
      this.$showLoading()
      if (bl) {
        if (this.pageNo >= this.pages) {
          this.pageNo = 1
        } else {
          this.pageNo++
        }
      } else {
        this.pageNo = 1
      }
      return recommendedMedicase({
        page: this.pageNo,
        departmentId: this.depId
      }).then(res => {
        setTimeout(() => {
          this.$hideLoading()
        }, 300)
        if (res.code === 200) {
          this.recommendList = res.data.items
          this.pages = res.data.pages
        } else {
          this.$toast(res.message)
        }
      })
    },
    controlPop(val, bl) {
      // bl 是否更新推荐
      this.openPop = val
      if (bl) {
        this.getRecommend()
      }
    },
    shareFn() {
      appShare(this.shareInfo)
    },
    wxShare(depId) {
      var query = this.$route.query
      if (!query.depId && depId) {
        query.depId = depId
      }
      this.shareInfo.url += '?' + queryToString(query)
      weixinShare(this.shareInfo)
    },
    toCollection() {
      if (appPort()) {
        jumpModuleApp({
          typeId: 'smart_exercise_collection_list'
        })
      } else {
        callAppView(this.extinfo)
      }
    },
    handleLaunchFn() {
      // 回调成功，判断是否唤起app
      let fn = function () {
        let timeOut = setTimeout(() => {
          if (document.visibilityState === 'visible') {
            if (androidPort()) {
              window.open(
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.example.haoyishu'
              )
            } else {
              window.open(
                'https://apps.apple.com/cn/app/%E5%A5%BD%E5%8C%BB%E6%9C%AF/id1080080087'
              )
            }
          } else {
            clearTimeout(timeOut)
            document.removeEventListener('visibilitychange', fn, false)
          }
        }, 1500)
      }
      document.addEventListener('visibilitychange', fn, false)
    },
    handleErrorFn(err) {
      let errMsg = err.detai.errMsg
      if (errMsg === 'launch:fail_check fail') {
        // appId 校验失败
        this.$toast('appId校验失败')
      } else if (errMsg === 'launch:fail') {
        // 跳转失败 手机上可能没有安装App
        this.$toast('请确认是否安装好医术APP')
      }
    },
    launchReady(e) {
      // console.log(e, 'ready')
    },
    remToPx(n) {
      var rem = localStorage.getItem('rem')
      return (n * Number(rem)) / 100
    }
  },
  created() {
    this.grayBl = !versionCompare('6.8.1')
    this.showHeader = versionCompare('6.0.1')
    if (this.showHeader) {
      // 隐藏手机webview导航栏
      hiddenAppNavBar()
    }
    if (wechatPort()) {
      this.btnStyle = {
        width: this.remToPx(114) + 'px',
        height: this.remToPx(186) + 'px'
      }
    }
  },
  async mounted() {
    this.$showLoading()
    await this.getUserMsg()
    if (this.userInfo.tagged) {
      // 判断用户是否选择标签
      await this.getRecommend()
    } else {
      this.openPop = /^(MEMBER|TRIAL)/.test(this.userInfo.role)
    }
    this.$hideLoading()
    this.loaded = true
    if (!this.isApp) {
      this.$nextTick(() => {
        this.bs = new BScroll('.exerciseTop', {
          scrollX: true,
          scrollY: false,
          click: true
        })
      })
    }
  },
  components: {
    Header,
    hotCases,
    MedicaseItem,
    chooseInterest
  }
})
</script>
<style lang="scss" scoped>
.exerciseContainer {
  min-height: 100vh;
  background: #f5f5f7;
}
.headerContainer {
  .headerRight {
    min-width: 2.2rem !important;
  }
}

.shareWrapper {
  height: 0.88rem;
  display: flex;
  align-items: center;
  padding-right: 0.22rem;
  .report {
    width: 0.56rem;
    height: 0.56rem;
    background: url('~@/assets/img/exercise/reportIcon.png') no-repeat;
    background-size: 100% 100%;
  }
  span {
    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #212224;
    line-height: 0.4rem;
  }
}
.exerciseTop {
  width: 7.5rem;
  margin: 0 auto;
  overflow: hidden;
  padding: 0.32rem 0 0.48rem;
  .infoWrapper {
    padding: 0 0.32rem;
    width: 7.5rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .browserPort {
    width: 7.5 + 1.4rem;
    .infoItem {
      width: 140px;
      border-radius: 12px;
      overflow: hidden;
    }
  }
  .exerciseCollectionGray {
    color: #969799;
  }
  .infoItem {
    width: 1.54rem;
    height: 218px;
    background: #fffdfc;
    border-radius: 12px;
    font-size: 32px;
    line-height: 44px;
    box-sizing: border-box;
    padding: 0.28rem 0 0 0.24rem;
    position: relative;
  }
  .wechatItem {
    background: #fff url('~@/assets/img/exercise/collectionIcon.png') no-repeat
      right bottom;
    background-size: 1.04rem 0.9rem;
    &:after {
      display: block;
      content: '收藏';
      position: absolute;
      left: 0.24rem;
      top: 0.28rem;
      color: #212224;
    }
  }
  .recordIcon {
    background: url('~@/assets/img/exercise/recordIcon.png') no-repeat;
    background-size: 100% 100%;
  }
  .collectionIcon {
    background: url('~@/assets/img/exercise/collectionIcon.png') no-repeat;
    background-size: 100% 100%;
  }
  .collectionIconGray {
    background: url('~@/assets/img/exercise/collectionIcon_gray.png') no-repeat;
    background-size: 100% 100%;
  }
  .reportIcon {
    background: url('~@/assets/img/exercise/report.png') no-repeat;
    background-size: 100% 100%;
  }
  .recordIcon,
  .collectionIcon,
  .collectionIconGray,
  .reportIcon {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 1.04rem;
    height: 0.9rem;
  }
}
.exerciseInterests {
  width: 3.3rem;
  height: 1.54rem;
  background: url('~@/assets/img/exercise/interests.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 12px;
  overflow: hidden;
  .thisWeek {
    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969799;
    line-height: 0.4rem;
    padding: 0.28rem 0 0.16rem 0.24rem;
  }
  .promptText {
    font-size: 0.36rem;
    height: 66px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #212224;
    padding-left: 0.24rem;
    .testInfo {
      height: 66px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      display: flex;
      align-items: baseline;
      line-height: 1;
    }
    .num {
      font-family: DINEngschrift;
      font-size: 56px;
      padding: 0 4px;
    }
  }
}
.interestsTime {
  width: 3.3rem;
  height: 0.64rem;
  background: #6183f2;
  border-radius: 0 0 0.12rem 0.12rem;
  display: flex;
  justify-content: center;
  color: #ffffff;
  align-items: center;
  box-sizing: border-box;
  .interestsValidity {
    font-size: 0.28rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 0.64rem;
    text-align: center;
  }
  .interestsBtn {
    width: 0.96rem;
    height: 0.32rem;
    border-radius: 0.16rem;
    border: 0.01rem solid #f5f5f7;
    margin-left: 0.08rem;
    box-sizing: border-box;
    text-align: center;
    font-size: 0.2rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }
  .expiredBtn {
    width: 76px;
    height: 32px;
    background: #f95046;
    border-radius: 16px;
    text-align: center;
    font-size: 0.2rem;
    line-height: 34px;
    margin: 0 0 0 8px;
  }
}
.exerciseCenter {
  width: 6.86rem;
  height: 6.8rem;
  background: url('~@/assets/img/exercise/practice_task.png') no-repeat;
  background-size: 100% 100%;
  margin: 0 0.32rem 0.64rem;
  position: relative;
  .exerciseReceive {
    position: absolute;
    right: 0.6rem;
    bottom: 0.64rem;
    width: 5.66rem;
    height: 0.88rem;
    background: #eeba78;
    border-radius: 0.44rem;
    text-align: center;
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #794000;
    line-height: 0.88rem;
  }
}
.recommentWrapper {
  width: 686px;
  background: url('~@/assets/img/exercise/recommend_bg.png') no-repeat center
    top;
  background-size: 100% 100%;
  margin: 0 auto 0.64rem;
  overflow: hidden;
  border-radius: 12px;
  .reloadOther {
    height: 32px;
    width: 4rem;
    margin: 8px auto 0;
    line-height: 32px;
    text-align: center;
    font-size: 28px;
    color: #626366;
    position: relative;
    padding-bottom: 32px;
    padding-top: 44px;
    margin-top: -32px;
    z-index: 8;
  }
}
.recommendTitle {
  height: 40px;
  line-height: 40px;
  padding-top: 40px;
  font-size: 37px;
  justify-content: space-between;
  padding: 40px 20px 16px;
  align-items: center;
  line-height: 1;
  .icon-change {
    margin-bottom: 5px;
  }
  dt {
    color: #000;
    font-weight: bold;
  }
  dd {
    font-size: 28px;
    color: #626366;
  }
}
.line {
  position: absolute;
  bottom: 0;
  border-bottom: 2px solid rgba(92, 69, 10, 0.1);
  left: 24px;
  right: 24px;
}
</style>
